export enum MapCallbackEnum {
  layerMouseEnter = 'layerMouseEnter',
  layerMouseLeave = 'layerMouseLeave',
  layerOpacityMouseEnter = 'layerOpacityMouseEnter',
  layerOpacityMouseLeave = 'layerOpacityMouseLeave',
  searchMouseEnter = 'searchMouseEnter',
  searchMouseLeave = 'searchMouseLeave',
  collapsedStateChange = 'collapsedStateChange',
  layersVisibilityChanged = 'layersVisibilityChanged'
}
